export default "__VITE_ASSET__BFU6zq$4__"